import { useEffect } from 'react';
import { ToastContainer } from 'lift-ui';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import SizeDialog from '@lift-admin/ui/size-dialog';
import Home from './features/home.component';
import Auth from './features/auth';
import ProtectedRoute from './shared/protected-route';
import PrivateRoute from './shared/components/protected-route';
import AdminRedirect from './features/auth/components/admin-redirect/admin-redirect';
import { usePostHog } from 'posthog-js/react';
import { ActionLogTrack } from '@lift-admin/utils/actionLogTrack';
import { useAuthContext } from '@lift-admin/utils/provider';
import { ProcessProvider } from './features/trigger/process-context';

export let actionLog: ActionLogTrack | undefined;

function App() {
  const posthog = usePostHog();

  const identifyUser = (id: any, properties: any) => {
    // console.log('Identifying user:', id, properties);
    posthog.identify(id, properties);
  };

  const captureEvent = (eventName: any, properties: any) => {
    // console.log('Capturing event:', eventName, properties);
    posthog.capture(eventName, properties);
  };

  let user: { id: number; email?: string; name?: string; [key: string]: any } | null = null;
  try {
    user = JSON.parse(localStorage.getItem('user') as any);
  } catch {
    user = null;
  }

  // Initialize actionLog whenever we have a user (same as main: ensures logging works after login and on refresh)
  if (user?.id) {
    if (!actionLog || actionLog.currentUser?.()?.id !== user.id) {
      actionLog = new ActionLogTrack({
        id: user.id,
        email: user.email ?? '',
        name: user.name ?? '',
        image: user.image,
      });
    }
  }

  useEffect(() => {
    // Get user data from localStorage
    const currentUser = user;
    if (currentUser) {
      // Identify the user with their unique ID and properties
      identifyUser(currentUser.id, {
        email: currentUser.email,
        name: currentUser.name,
        brand: currentUser.brand,
        is_admin: currentUser.is_admin,
        image: currentUser.image,
        team: currentUser.team,
        position: currentUser.position,
        mobile: currentUser.mobile,
        admin: currentUser.admin,
      });

      // Track each item in localStorage as an event
      Object.keys(localStorage).forEach((key) => {
        captureEvent('LIFT_V2.0_Admin_item', {
          key: currentUser.id,
          value: localStorage.getItem(key),
        });
      });
    }
  }, [posthog, user]);

  return (
    <>
    <ProcessProvider>

      <BrowserRouter>
        {/* <PreLoader /> */}
        <ToastContainer className="pointer-events-auto" />
        <Routes>
          <Route path="/" element={<Auth />} />
          <Route path="/home" element={<Navigate to="/overview" replace />} />
          <Route path="/home/:section" element={<Navigate to={window.location.pathname.replace('/home/', '/')} replace />} />
          <Route
            path="/:section"
            element={
              <ProtectedRoute>
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              </ProtectedRoute>
            }
          />
          <Route path="/adminRedirect" element={<AdminRedirect />} />
        </Routes>
      </BrowserRouter>
      <SizeDialog />
    </ProcessProvider>
    </>
  );
}

export default App;
